/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

export const EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
export const NUMBERS_PATTERN = '^-?[0-9]+$';
export const DOUBLE_PATTERN = '[+-]?([0-9]*[.])?[0-9]+';
export  const SPECIAL_CHARACTERS = '!@#\$%\^&\*';

// WASA (invalid input validation). A person's name: letters of any script (Latin, Tamil, Devanagari,
// Arabic, CJK, Hangul ...), combining marks, digits, space and  . , ' (also the typographic ') - / ( ) _
// Anything that could form markup (< > " ; { } & ...) is refused. The API enforces the same rule
// (InputRules.IsPersonName) - this only gives the user an immediate message.
export const NAME_PATTERN = '^[A-Za-z0-9 .,\'\\u2019\\u00A0\\u200C\\u200D\\-/()_\\u00C0-\\u02AF\\u0300-\\u036F\\u0370-\\u1FFF\\u3040-\\u30FF\\u3400-\\u4DBF\\u4E00-\\u9FFF\\uAC00-\\uD7AF\\uFB50-\\uFDCF\\uFE70-\\uFEFC]+$';

// Short free text (address line): everything except angle brackets and control characters.
export const SAFE_TEXT_PATTERN = '^[^<>\\u0000-\\u001F\\u007F]+$';

// A user (login) name: same as NAME_PATTERN, and also @ and + (e-mail style names, +91 numbers).
// Matches InputRules.IsUserName on the API.
export const USER_NAME_PATTERN = '^[A-Za-z0-9 .,\'\\u2019\\u00A0\\u200C\\u200D\\-/()_@+\\u00C0-\\u02AF\\u0300-\\u036F\\u0370-\\u1FFF\\u3040-\\u30FF\\u3400-\\u4DBF\\u4E00-\\u9FFF\\uAC00-\\uD7AF\\uFB50-\\uFDCF\\uFE70-\\uFEFC]+$';
